// FPEL 2024. Pure data — see src/seasons/index.js.
const season2024 = {
  season: 2024,
  leagueId: 175750856,
  label: 'Season 2',
  results: {
    champion: {
      team: 'Maximilien Robespierre',
      manager: null,
      note: "Everyone's favorite league villain",
    },
    runnerUp: null,
    firstOut: { team: 'Pink Pony Boy', week: 4 },
  },
};

export default season2024;
